import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { InvestSic } from '@classes/invest/invest-sic/invest-sic';
import { InvestService } from '@services/invest.service';
import { InvestYear } from '@classes/invest/invest-simulation/invest-year';
import { ProviderType } from '@enums/provider-type.enum';

@Component({
    selector: 'app-sic-datatable',
    templateUrl: './sic-datatable.component.html',
    styleUrls: ['./sic-datatable.component.scss']
})
export class SicDatatableComponent implements OnInit, OnDestroy {
    @Input() invest: InvestSic;
    private investSub: Subscription;

    constructor(
        private investSrv: InvestService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    getItemValue(year: InvestYear, code: string): number {
        const item = year.items.find(i => i.code === code);

        return item ? item.value :  null;
    }

    checkError(year: InvestYear, code: string): boolean {
        const value = this.getItemValue(year, code);

        switch(code) {
            case 'extraFund':
                return value < 0 || value < this.getItemValue(year, 'fundVariation');
            case 'fundVariation':
                return this.getItemValue(year, 'extraFund') < value;
            case 'balance':
                return value < this.investSrv.sumProjectsYearProperty(this.invest.fundingProject.projects, year.year, 'ordinaryLevy');
            default:
                return false;
        }
    }

    onValueChanged(value: number, year: InvestYear, code: string): void {
        year.items.find(i => i.code === code).value = value;

        if(code === 'extraFund') {
            this.investSrv.calculateExtraFund(this.invest);
        }

        this.investSrv.investChanged.next(this.invest);
    }

    private initSubscriptions(): void {
        this.investSub = this.investSrv.investChanged
        .subscribe(invest => {
            if(invest && invest.simulation.provider !== ProviderType.bbc) {
                this.invest = <InvestSic>invest;
            }
        });
    }

    ngOnDestroy(): void {
        if(this.investSub) {
            this.investSub.unsubscribe();
        }
    }
}
